import { get, getPBI, postPBI } from "../../../../services/request"

export const getCoverageGapToolLastRefreshed = (reportCode) => {
    return get('PowerBIReport/GetLastRefreshedDateTime', {
        ReportCode: "COVERAGEGAPTOOL"
    });
}

export const getCoverageGapToolEncorePowerBIToken = () => {
    return postPBI({
        url: window.configuration.POC_REPORT_FLOWURL,
        headers: { "Accept": "application/json" }
    })
}

export const getCoverageGapToolEncoreEmbedResponse = ({ token, reportId, workspaceId }) => {
    return getPBI({
        url: `${window.configuration.POWER_BI_GROUP_URL}/${workspaceId}/reports/${reportId}`,
        token,
    })
}

export const getCoverageGapToolEncoreMultiResourceTokenResponse = ({ token, reportId, goldenDatasetId, datasetId, reportWorkspaceId, datasetWorkspaceId }) => {
    return postPBI({
        url: window.configuration.POWER_BI_GENERATE_TOKEN_URL,
        token,
        body: JSON.stringify({
            datasets: [
                { id: goldenDatasetId },
                { id: datasetId }
            ],
            reports: [{ id: reportId, allowEdit: false }],
            targetWorkspaces: [
                { id: reportWorkspaceId },
                { id: datasetWorkspaceId }
            ]
        })
    })
}
